module.exports = __webpack_public_path__ + "img/log_b.54f95973.png";